export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const LOAN_APPLICATION = "/loan-application";
export const VEHICAL_CLASS = "/vehicle/class";
export const APPLICANT = "/applicant";
export const EMPLOYMENT = "/employment";
export const INCOME = "/income";
export const ASSST_LIABILITY = "/asset-liability";
export const DOCUMENT_PASSPORT = "/document";
